import { Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, title, subtitle, image, testid }) => (
    <section className="relative overflow-hidden bg-[#0B1528] pb-20 pt-36 sm:pb-24 sm:pt-44">
        {image && (
            <>
                <img
                    src={image}
                    alt=""
                    className="absolute inset-0 h-full w-full object-cover opacity-25"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#0B1528]/70 via-[#0B1528]/85 to-[#0B1528]" />
            </>
        )}
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal>
                <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#60A5FA]">
                    {eyebrow}
                </p>
            </Reveal>
            <Reveal delay={90}>
                <h1
                    data-testid={testid}
                    className="mt-4 max-w-3xl text-4xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-5xl"
                >
                    {title}
                </h1>
            </Reveal>
            <Reveal delay={180}>
                <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
                    {subtitle}
                </p>
            </Reveal>
        </div>
    </section>
);
